import CustService from "../../services/rateService/service";   
import custModel from "../../models/rateModel/model";

export default {
    async fetchCust(period, search, page, limit) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const response = await CustService.getCust(period, sanitizedSearch, page, limit);
            return {
                data: response.data.map(cust => new custModel(cust)),
                total: parseInt(response.headers['x-total-count'], 10),
            }
        } catch (error) {
            console.error('Error fetching customers:', error);
            throw error;
        }
    },

    async fetchQuestion() {
        try {
            const response = await CustService.fetchQuestion();
            return response;
        } catch (error) {
            console.error('Error fetching services:', error);
            throw error;
        }
    },

    async totalAllCust(search) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            return await CustService.totalAllCust(sanitizedSearch);
        } catch (error) {
            console.error('Error fetching customers:', error);
            throw error;
        }
    },

    async addCust(cust) {
        try {
            return await CustService.addCust(cust);
        } catch (error) {
            console.error('Error adding customer:', error);
            throw error;
        }
    },

    async updateCust(cust) {
        try {
            return await CustService.updateCust(cust);
        } catch (error) {
            console.error('Error updating customer:', error);
            throw error;
        }
    },

    async deleteCust(custId) {
        try {
            return await CustService.deleteCust(custId);
        } catch (error) {
            console.error('Error deleting customer:', error);
            throw error;
        }
    },

    async downloadRateList(periode){
        try {
            const response = await CustService.downloadRateList(periode);
            const data = response.data[0];
            // Pisahkan kolom 'questions' menjadi dua kolom: question1, question2
            const processedData = data.map(item => {
                const [question1, question2] = item.questions.split(';').map(q => q.trim());
                const [answer1, answer2] = item.answers?.split(';').map(a => a.trim()) || ["", ""];
                return {
                    name: item.name,
                    name_company: item.name_company,
                    question1,
                    answer1,
                    question2,
                    answer2,
                    total_score: item.total_score,
                    created_on: item.created_on,
                };
            });
            return processedData;
        } catch (error) {
            console.error('Error downloading rate list:', error);
            throw error;
        }
    }
}